import TranslationExample from "../../../../content/posts/display-translation-audio/TranslationExample";
import * as React from 'react';
export default {
  TranslationExample,
  React
};